export enum VerificationStepEnum {
    CAMERA_ACCESS,
    SCANNING,
    COMPLETED,
    FAILED,
}
